import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cfb75cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "services" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Service = _resolveComponent("Service")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Service, {
      title: "Front End",
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minima beatae enim tenetur, dicta id tempore asperiores iste quasi aliquid, veniam consequuntur ratione nulla incidunt maxime sunt nostrum rem quis! Eos."
    }),
    _createVNode(_component_Service, {
      title: "Back End",
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minima beatae enim tenetur, dicta id tempore asperiores iste quasi aliquid, veniam consequuntur ratione nulla incidunt maxime sunt nostrum rem quis! Eos."
    }),
    _createVNode(_component_Service, {
      title: "Manutenção",
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minima beatae enim tenetur, dicta id tempore asperiores iste quasi aliquid, veniam consequuntur ratione nulla incidunt maxime sunt nostrum rem quis! Eos."
    })
  ]))
}